import { useEffect, useState } from "react";
import { FieldError, UseFormRegister, UseFormSetValue } from "react-hook-form";
import { useAxios } from "../../utils/useAxios";
import { Button, CircularProgress } from "@mui/material";
import { Modal } from "../ui/modal";
import FormBuildTabs from "../../plugins/formBuilder/FormBuildTabs";
import { useModal } from "../../hooks/useModal";
import MuiModel from "../Mui/model/MuiModel";
import { useFilterData } from "../../context/TableDataContext";

interface MyCreateSelectProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  name: string;
  register: UseFormRegister<any>;
  setValue: UseFormSetValue<any>;
  error?: FieldError;
  validationRules?: object;
  selected?: any;
  createName?: string;
  labelKey?: string;
  valueKey?: string;
  searching_key?: string;
  display_searching_key?: string;
}
export function MySearch({
  name,
  register,
  setValue,
  error,
  validationRules,
  selected,
  createName,
  labelKey = "factoring_name",
  valueKey = "id",
  searching_key = "id",
  display_searching_key = "name",
  ...rest
}: MyCreateSelectProps) {
  const [inputValue, setInputValue] = useState("");

  const { setFilterData } = useFilterData();

  const {
    res: searchRes,
    mutate: searchMutate,
    isPending: searchIsPending,
  } = useAxios({ url: "/api/auth/filterLoad" });

  const getFilterData = () => {
    searchMutate({
      searchKey: name,
      searchValue: inputValue,
    });
  };

  useEffect(() => {
    if (searchRes) {
      setFilterData(searchRes?.data?.data);
    }
  }, [searchRes]);

  //console.log(inputValue);
  return (
    <div className="relative w-full">
      <input
        onChange={(e) => setInputValue(e.target.value)}
        value={inputValue}
        type="search"
        className="h-7 w-full border px-1 py-1 text-xs shadow-theme-xs placeholder:text-gray-400 focus:outline-none focus:ring bg-transparent text-gray-800 border-gray-300 focus:border-brand-300 focus:ring focus:ring-brand-500/10"
        required={rest?.required}
        aria-required={rest?.required}
      />
      <button
        onClick={getFilterData}
        className="absolute top-0 end-0 px-1.5 text-sm font-xs h-full text-white bg-blue-700  border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
      >
        <svg
          className="w-3 h-3"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 20 20"
        >
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
          />
        </svg>
        <span className="sr-only">Search</span>
      </button>
    </div>
  );
}
